import config from "../../config/domain";
import GlobalStore from "../store/globalStore";
import requestMapper from "./mapper/serviceMapper";
import servicesList from "./serviceList";
import { trackApiError } from "./apiErrorTracker";

interface callReq {
  url: string;
  body: {};
  method?: string;
  apiBaseUrl?: string;
  tempToken?: string;
  serviceName?: string;
  isNewUrl?: boolean;
}

export const xhrApiService = async (
  req: callReq,
  callback: CallableFunction,
  onProgress?: Function,
  method?: string,
  apiBaseUrl?: string,
  serviceName?: string,
  tempToken?: string,
  isNewUrl?: boolean
) => {
  let xhr = new XMLHttpRequest();

  // track upload progress
  xhr.upload.onprogress = function (event) {
    onProgress && onProgress(event);
  };

  xhr.onerror = function () {
    trackApiError({
      url: req.url,
      serviceName,
      errorType: "network",
      message: "upload request failed",
    });
  };

  // track completion: both successful or not
  xhr.onloadend = async function (res) {
    resolveResult(res);
    // if (serviceName && serviceName !== "") {
    //   let result = await requestMapper(this.responseText, serviceName);
    //   callback(result);
    // } else {
    //   callback(res);
    // }
    // if (xhr.status === 200) {
    //   // callback(JSON.parse(this.responseText));
    // } else {
    //   callback(undefined);
    // }
  };

  const resolveResult = async (res: any) => {
    console.log("resolveResult", serviceName, res.currentTarget.responseText);
    if (res.currentTarget) {
      if (res.currentTarget.responseText) {
        let parsed: any;
        try {
          parsed = JSON.parse(res.currentTarget.responseText);
        } catch (e) {
          trackApiError({
            url: req.url,
            serviceName,
            httpStatus: xhr.status,
            errorType: "network",
            message: "invalid upload response",
          });
          callback(res.currentTarget);
          return;
        }

        trackApiError({
          url: req.url,
          serviceName,
          httpStatus: xhr.status,
          response: parsed,
        });

        let result = await requestMapper(
          parsed,
          servicesList.uploadDocumentToS3
        );
        if (result) {
          callback(result);
        }
      } else {
        trackApiError({
          url: req.url,
          serviceName,
          httpStatus: xhr.status,
          errorType: "network",
          message: "empty upload response",
        });
        callback(res.currentTarget);
      }
    }
  };

  xhr.open(method ? method : "POST", `${config.diyNewApiUrl}${req.url}`);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.setRequestHeader("api-key", config.apiKey);
  let clientPartialDetails = JSON.parse(
    window.localStorage.getItem("clientPartialDetails_ao") || "{}"
  );
  if (GlobalStore.token !== "") {
    xhr.setRequestHeader("Authorization", `Bearer ${GlobalStore.token}`);
  }

  if (!GlobalStore.token && clientPartialDetails.token) {
    xhr.setRequestHeader(
      "Authorization",
      `Bearer ${clientPartialDetails.token}`
    );
  }
  xhr.send(JSON.stringify(req.body));
};
